// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("styles/img/icon-statement.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("styles/img/icon-deposit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("styles/img/icon-exit.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__section___kawNL {
}

.styles__sectionNoMargin___GuENv {
}

.styles__cardMarginBot___v3VP6 {
}

.styles__sectionTitle___OX6_E {
}

.styles__sectionSmall___oOL_t {
}

.styles__contentContainer___WzbjW {
  padding-top: 32px;
  display: flex;
}

.styles__oneThird____lMZ1 {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
}

.styles__oneThird____lMZ1:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__oneThird____lMZ1:last-child {
  margin-right: 0;
}

.styles__oneThird____lMZ1:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__oneThird____lMZ1:nth-child(3n + 1) {
  clear: both;
}

@media only screen and (max-width: 768px) {

.styles__oneThird____lMZ1 {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}

.styles__oneThird____lMZ1:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}

.styles__oneThird____lMZ1:last-child {
    margin-right: 0;
}

.styles__oneThird____lMZ1:nth-child(1n) {
    margin-right: 0;
    float: right;
}

.styles__oneThird____lMZ1:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__twoThird___WZLH5 {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.styles__twoThird___WZLH5:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__twoThird___WZLH5:last-child {
  margin-right: 0;
}

.styles__twoThird___WZLH5:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__twoThird___WZLH5:nth-child(3n + 1) {
  clear: both;
}

@media only screen and (max-width: 768px) {

.styles__twoThird___WZLH5 {
    width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
}

.styles__twoThird___WZLH5:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
}

.styles__twoThird___WZLH5:last-child {
    margin-right: 0;
}

.styles__twoThird___WZLH5:nth-child(1n) {
    margin-right: 0;
    float: right;
}

.styles__twoThird___WZLH5:nth-child(1n + 1) {
    clear: both;
}
  }

.styles__oneHalf___sVUhs {
  width: calc(99.9% * 1/2 - (30px - 30px * 1/2));
}

.styles__oneHalf___sVUhs:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__oneHalf___sVUhs:last-child {
  margin-right: 0;
}

.styles__oneHalf___sVUhs:nth-child(2n) {
  margin-right: 0;
  float: right;
}

.styles__oneHalf___sVUhs:nth-child(2n + 1) {
  clear: both;
}

.styles__row___sp1I3 {
}

.styles__rowTop___Q1mqA {
}

.styles__body___o4Q8X,
.styles__header___Bcnws {
  align-items: stretch;
  width: 100%;
}

.styles__actions___hM6Ux {
  display: grid;
  background: white;
  border-bottom: 0;
  /* stylelint-disable */
  grid-template-columns: repeat(2, 1fr);
  /* stylelint-enable */
  margin-bottom: 20px;
  border-radius: 3px;
}

.styles__actions___hM6Ux :nth-child(odd) {
    border-right: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
    border-radius: 3px 0 0 3px;
  }

.styles__actions___hM6Ux :nth-child(even) {
    border-radius: 0 3px 3px 0;
  }

.styles__actionButton___lOvuj {
  display: flex;
  height: 50px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
  font-weight: 600;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10%;
  width: 100%;
  box-shadow: none;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
}

.styles__actionButton___lOvuj:hover {
    box-shadow: none;
    background: #f8f8f8;
  }

.styles__editButton___hWXqq {
}

.styles__editButton___hWXqq::before {
    content: '';
    height: 100%;
    width: 36px;
    margin-bottom: 2px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 16px;
  }

.styles__statementButton___f9TFv {
}

.styles__statementButton___f9TFv::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }

.styles__depositButton___r_KQH {
}

.styles__depositButton___r_KQH::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }

.styles__closingButton___MnvQY {
  cursor: pointer;
}

.styles__closingButton___MnvQY::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }

.styles__addButton___qci7l {
}

.styles__plus___gNT9f {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  margin-right: 10px;
  font-size: 18px;
}

.styles__titleBox___J5hWF {
  position: relative;
}

.styles__crumbs___I740y {
  width: calc(99.9% * 2/3 - (30px - 30px * 2/3));
}

.styles__crumbs___I740y:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__crumbs___I740y:last-child {
  margin-right: 0;
}

.styles__crumbs___I740y:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__crumbs___I740y:nth-child(3n + 1) {
  clear: both;
}

.styles__updated___w8MAg {
  width: calc(99.9% * 1/3 - (30px - 30px * 1/3));
  text-align: right;
}

.styles__updated___w8MAg:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__updated___w8MAg:last-child {
  margin-right: 0;
}

.styles__updated___w8MAg:nth-child(3n) {
  margin-right: 0;
  float: right;
}

.styles__updated___w8MAg:nth-child(3n + 1) {
  clear: both;
}

.styles__statusActive___cH1uf {
}

.styles__statusPending___ptfsx {
}

.styles__statusRejected___yLSA_ {
}

.styles__accountNumber___afhPM {
  font-size: 14px;
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  padding: 4px 8px;
}

.styles__beneName___WMSeW {
  font-weight: 600;
  font-size: 28px;
  box-shadow: none;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]};
}

.styles__balanceWrapper___UyNdB {
  width: calc(99.9% * 2/5 - (30px - 30px * 2/5));
  text-align: right;
}

.styles__balanceWrapper___UyNdB:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__balanceWrapper___UyNdB:last-child {
  margin-right: 0;
}

.styles__balanceWrapper___UyNdB:nth-child(1n) {
  margin-right: 0;
  float: right;
}

.styles__balanceWrapper___UyNdB:nth-child(1n + 1) {
  clear: both;
}

.styles__balance___DeQEN {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]};
  font-weight: 600;
  font-size: 28px;
}

.styles__button___HIiVz {
  margin-left: 20px;
}

.styles__button___HIiVz:first-child {
    margin-left: 0;
  }

.styles__buttonLocal___cAg_T {
  margin-left: 8px;
}

.styles__buttonLocal___cAg_T:first-child {
    margin-left: 0;
  }

.styles__buttonLocal___cAg_T.styles__disabled___DmHdb {
  display: none;
}

.styles__buttonSecondary___UBnRO {
  margin-left: 20px;
}

.styles__buttonSecondary___UBnRO:first-child {
    margin-left: 0;
  }

.styles__accountExtras___xKxhS {
  margin-bottom: 20px;
}

.styles__tabList___Qs5jY {
  background: none;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  height: 100%;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-flow: wrap;
  list-style: none;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
  margin: 10px 0 24px;
  padding: 0;
}

.react-tabs__tab--selected {
    font-weight: 600;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
    border-bottom: 3px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
    margin-bottom: 0;
  }

.react-tabs__tab {
    opacity: 1;
    height: 50px;
    cursor: pointer;
    padding: 16px 10px;
    text-transform: capitalize;
  }

.styles__titleSection___HWJX4 {
  padding-bottom: 10px;
  padding-top: 10px;
}

.styles__titleName___wK87G {
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
  margin-top: -5px;
}

.styles__formItemMono___GsY4T {
  margin-bottom: 16px;
}

.styles__label___v2CbV {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #495057;
  font-size: 14px;
}

.styles__select___IBois {
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Account/components/Number/Main/styles.css"],"names":[],"mappings":"AAIA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EAEE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;;AAHF;IAII,8CAAkB;AAEtB;;AANA;IAII,WAAkB;IAAlB,kBAAkB;IAAlB,WAAkB;AAEtB;;AANA;IAII,eAAkB;AAEtB;;AANA;IAII,eAAkB;IAAlB,YAAkB;AAEtB;;AANA;IAII,WAAkB;AAEtB;EADE;;AAGF;EACE,8CAAgB;AAKlB;;AANA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAKlB;;AANA;EACE,eAAgB;AAKlB;;AANA;EACE,eAAgB;EAAhB,YAAgB;AAKlB;;AANA;EACE,WAAgB;AAKlB;;AAHE;;AAHF;IAII,8CAAkB;AAEtB;;AANA;IAII,WAAkB;IAAlB,kBAAkB;IAAlB,WAAkB;AAEtB;;AANA;IAII,eAAkB;AAEtB;;AANA;IAII,eAAkB;IAAlB,YAAkB;AAEtB;;AANA;IAII,WAAkB;AAEtB;EADE;;AAGF;EACE,8CAAkB;AACpB;;AAFA;EACE,WAAkB;EAAlB,kBAAkB;EAAlB,WAAkB;AACpB;;AAFA;EACE,eAAkB;AACpB;;AAFA;EACE,eAAkB;EAAlB,YAAkB;AACpB;;AAFA;EACE,WAAkB;AACpB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;;EAEE,oBAAoB;EAEpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EAEjB,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AAUpB;;AARE;IACE,oEAAmC;IACnC,0BAA0B;EAC5B;;AAEA;IACE,0BAA0B;EAC5B;;AAGF;EACE,aAAa;EACb,YAAY;EACZ,mDAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,qEAAoC;AAMtC;;AAJE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;AAGF;AAaA;;AAVE;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,yDAAiD;IACjD,2BAA2B;IAC3B,4BAA4B;IAC5B,qBAAqB;EACvB;;AAGF;AAMA;;AAHE;IACE,yDAAsD;EACxD;;AAGF;AAMA;;AAHE;IACE,yDAAoD;EACtD;;AAGF;EAEE,eAAe;AAKjB;;AAHE;IACE,yDAAiD;EACnD;;AAGF;AAEA;;AAEA;EACE,mDAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EACE,8CAAgB;AAClB;;AAFA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAFA;EACE,eAAgB;EAAhB,YAAgB;AAClB;;AAFA;EACE,WAAgB;AAClB;;AAEA;EACE,8CAAgB;EAChB,iBAAiB;AACnB;;AAHA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAElB;;AAHA;EACE,eAAgB;AAElB;;AAHA;EACE,eAAgB;EAAhB,YAAgB;AAElB;;AAHA;EACE,WAAgB;AAElB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,eAAe;EACf,wDAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mDAAe;AACjB;;AAEA;EACE,8CAAkB;EAClB,iBAAiB;AACnB;;AAHA;EACE,WAAkB;EAAlB,kBAAkB;EAAlB,WAAkB;AAEpB;;AAHA;EACE,eAAkB;AAEpB;;AAHA;EACE,eAAkB;EAAlB,YAAkB;AAEpB;;AAHA;EACE,WAAkB;AAEpB;;AAEA;EACE,mDAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EAEE,iBAAiB;AAKnB;;AAHE;IACE,cAAc;EAChB;;AAGF;EACE,gBAAgB;AAKlB;;AAHE;IACE,cAAc;EAChB;;AAGF;EACE,aAAa;AACf;;AAEA;EAEE,iBAAiB;AAKnB;;AAHE;IACE,cAAc;EAChB;;AAGF;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mDAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qEAAoC;EACpC,mBAAmB;EACnB,UAAU;AACZ;;AAGE;IACE,gBAAgB;IAChB,mDAAW;IACX,qEAA+B;IAC/B,gBAAgB;EAClB;;AAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,0BAA0B;EAC5B;;AAGF;EAEE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EAEE,sBAAsB;AACxB","sourcesContent":["@value helpers: 'styles/helpers.css';\n@value colors: 'styles/colors.css';\n@value gtGPT, gtBlue, textLight, gtBlueLight, borderColor, gtRed, gtGrayLight, gtGreen, text, textDark from colors;\n\n.section {\n  composes: section from helpers;\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n}\n\n.cardMarginBot {\n  composes: cardMarginBot from helpers;\n}\n\n.sectionTitle {\n  composes: sectionTitle from helpers;\n}\n\n.sectionSmall {\n  composes: sectionSmall from helpers;\n}\n\n.contentContainer {\n  composes: content-container from helpers;\n  padding-top: 32px;\n  display: flex;\n}\n\n.oneThird {\n  lost-column: 1/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n}\n\n.twoThird {\n  lost-column: 2/3;\n\n  @media only screen and (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n}\n\n.oneHalf {\n  lost-column: 1/2 2;\n}\n\n.row {\n  composes: row from helpers;\n}\n\n.rowTop {\n  composes: rowTop from helpers;\n}\n\n.body,\n.header {\n  align-items: stretch;\n  composes: row from helpers;\n  width: 100%;\n}\n\n.actions {\n  display: grid;\n  background: white;\n  composes: card from helpers;\n  border-bottom: 0;\n  /* stylelint-disable */\n  grid-template-columns: repeat(2, 1fr);\n  /* stylelint-enable */\n  margin-bottom: 20px;\n  border-radius: 3px;\n\n  :nth-child(odd) {\n    border-right: 1px solid borderColor;\n    border-radius: 3px 0 0 3px;\n  }\n\n  :nth-child(even) {\n    border-radius: 0 3px 3px 0;\n  }\n}\n\n.actionButton {\n  display: flex;\n  height: 50px;\n  color: text;\n  font-weight: 600;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0 10%;\n  width: 100%;\n  box-shadow: none;\n  border-bottom: 1px solid borderColor;\n\n  &:hover {\n    box-shadow: none;\n    background: #f8f8f8;\n  }\n}\n\n.editButton {\n  composes: actionButton;\n\n  &::before {\n    content: '';\n    height: 100%;\n    width: 36px;\n    margin-bottom: 2px;\n    background-image: url('styles/img/icon_edit.png');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: 16px;\n  }\n}\n\n.statementButton {\n  composes: editButton;\n\n  &::before {\n    background-image: url('styles/img/icon-statement.png');\n  }\n}\n\n.depositButton {\n  composes: editButton;\n\n  &::before {\n    background-image: url('styles/img/icon-deposit.png');\n  }\n}\n\n.closingButton {\n  composes: editButton;\n  cursor: pointer;\n\n  &::before {\n    background-image: url('styles/img/icon-exit.png');\n  }\n}\n\n.addButton {\n  composes: addButton from helpers;\n}\n\n.plus {\n  color: gtGreen;\n  margin-right: 10px;\n  font-size: 18px;\n}\n\n.titleBox {\n  composes: row;\n  position: relative;\n}\n\n.crumbs {\n  lost-column: 2/3;\n}\n\n.updated {\n  lost-column: 1/3;\n  text-align: right;\n}\n\n.statusActive {\n  composes: statusActive from helpers;\n}\n\n.statusPending {\n  composes: statusPending from helpers;\n}\n\n.statusRejected {\n  composes: statusRejected from helpers;\n}\n\n.accountNumber {\n  font-size: 14px;\n  background: gtBlue;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  padding: 4px 8px;\n}\n\n.beneName {\n  font-weight: 600;\n  font-size: 28px;\n  box-shadow: none;\n  color: textDark;\n}\n\n.balanceWrapper {\n  lost-column: 2/5 1;\n  text-align: right;\n}\n\n.balance {\n  color: textDark;\n  font-weight: 600;\n  font-size: 28px;\n}\n\n.button {\n  composes: button from helpers;\n  margin-left: 20px;\n\n  &:first-child {\n    margin-left: 0;\n  }\n}\n\n.buttonLocal {\n  margin-left: 8px;\n\n  &:first-child {\n    margin-left: 0;\n  }\n}\n\n.buttonLocal.disabled {\n  display: none;\n}\n\n.buttonSecondary {\n  composes: buttonSecondary from helpers;\n  margin-left: 20px;\n\n  &:first-child {\n    margin-left: 0;\n  }\n}\n\n.accountExtras {\n  margin-bottom: 20px;\n}\n\n.tabList {\n  background: none;\n  color: textLight;\n  height: 100%;\n  font-size: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-flow: wrap;\n  list-style: none;\n  border-bottom: 1px solid borderColor;\n  margin: 10px 0 24px;\n  padding: 0;\n}\n\n:global {\n  .react-tabs__tab--selected {\n    font-weight: 600;\n    color: text;\n    border-bottom: 3px solid gtBlue;\n    margin-bottom: 0;\n  }\n\n  .react-tabs__tab {\n    opacity: 1;\n    height: 50px;\n    cursor: pointer;\n    padding: 16px 10px;\n    text-transform: capitalize;\n  }\n}\n\n.titleSection {\n  composes: sectionSmall from helpers;\n  padding-bottom: 10px;\n  padding-top: 10px;\n}\n\n.titleName {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 5px;\n  margin-top: -5px;\n}\n\n.formItemMono {\n  margin-bottom: 16px;\n}\n\n.label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #495057;\n  font-size: 14px;\n}\n\n.select {\n  composes: select from helpers;\n  width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `'styles/helpers.css'`,
	"colors": `'styles/colors.css'`,
	"gtGPT": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"borderColor": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtGrayLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"textDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]}`,
	"section": `styles__section___kawNL ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"sectionNoMargin": `styles__sectionNoMargin___GuENv ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"cardMarginBot": `styles__cardMarginBot___v3VP6 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["cardMarginBot"]}`,
	"sectionTitle": `styles__sectionTitle___OX6_E ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"sectionSmall": `styles__sectionSmall___oOL_t ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]}`,
	"contentContainer": `styles__contentContainer___WzbjW ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"oneThird": `styles__oneThird____lMZ1`,
	"twoThird": `styles__twoThird___WZLH5`,
	"oneHalf": `styles__oneHalf___sVUhs`,
	"row": `styles__row___sp1I3 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"rowTop": `styles__rowTop___Q1mqA ${___CSS_LOADER_ICSS_IMPORT_1___.locals["rowTop"]}`,
	"body": `styles__body___o4Q8X ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"header": `styles__header___Bcnws ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"actions": `styles__actions___hM6Ux ${___CSS_LOADER_ICSS_IMPORT_1___.locals["card"]}`,
	"actionButton": `styles__actionButton___lOvuj`,
	"editButton": `styles__editButton___hWXqq styles__actionButton___lOvuj`,
	"statementButton": `styles__statementButton___f9TFv styles__editButton___hWXqq styles__actionButton___lOvuj`,
	"depositButton": `styles__depositButton___r_KQH styles__editButton___hWXqq styles__actionButton___lOvuj`,
	"closingButton": `styles__closingButton___MnvQY styles__editButton___hWXqq styles__actionButton___lOvuj`,
	"addButton": `styles__addButton___qci7l ${___CSS_LOADER_ICSS_IMPORT_1___.locals["addButton"]}`,
	"plus": `styles__plus___gNT9f`,
	"titleBox": `styles__titleBox___J5hWF styles__row___sp1I3 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"crumbs": `styles__crumbs___I740y`,
	"updated": `styles__updated___w8MAg`,
	"statusActive": `styles__statusActive___cH1uf ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusActive"]}`,
	"statusPending": `styles__statusPending___ptfsx ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusPending"]}`,
	"statusRejected": `styles__statusRejected___yLSA_ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["statusRejected"]}`,
	"accountNumber": `styles__accountNumber___afhPM`,
	"beneName": `styles__beneName___WMSeW`,
	"balanceWrapper": `styles__balanceWrapper___UyNdB`,
	"balance": `styles__balance___DeQEN`,
	"button": `styles__button___HIiVz ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"buttonLocal": `styles__buttonLocal___cAg_T`,
	"disabled": `styles__disabled___DmHdb`,
	"buttonSecondary": `styles__buttonSecondary___UBnRO ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"accountExtras": `styles__accountExtras___xKxhS`,
	"tabList": `styles__tabList___Qs5jY`,
	"titleSection": `styles__titleSection___HWJX4 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]}`,
	"titleName": `styles__titleName___wK87G`,
	"formItemMono": `styles__formItemMono___GsY4T`,
	"label": `styles__label___v2CbV`,
	"select": `styles__select___IBois ${___CSS_LOADER_ICSS_IMPORT_1___.locals["select"]}`
};
export default ___CSS_LOADER_EXPORT___;
